import { Box, Button, Grid, Modal } from '@mui/material';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CompanyNamePICModel from '../../../CompanyNamePIC/models/CompanyNamePICModel';
import CompanyNamePICSelector from '../../../CompanyNamePICSelector/CompanyNamePICSelector';
import { setCompanyName, setSelectedId, setSelectedItem, setShowPrincipleInput, setTriggerPrincipleChange, SupportSheetPrincipleSelector } from './reducers/SupportSheetPrincipleReducer';

const SupportSheetPrincipleModal: React.FunctionComponent = (props) => {
    const dispatch = useDispatch();
    const principleData = useSelector(SupportSheetPrincipleSelector);

    useEffect(() => {
    }, [])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "800px",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <>
            <Modal
                open={principleData.showInput}
                onClose={() => {
                    dispatch(setShowPrincipleInput(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item xs={10}>
                            <CompanyNamePICSelector
                                label='Company Name'
                                selectedId={principleData.selectedId}
                                onChange={(selectedItem: CompanyNamePICModel | null) => {
                                    dispatch(setSelectedId(selectedItem ? selectedItem.id : ""));
                                }}
                            >
                            </CompanyNamePICSelector>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                onClick={() => {
                                    dispatch(setTriggerPrincipleChange((new Date()).getTime()));
                                    dispatch(setShowPrincipleInput(false));
                                }}
                                variant="outlined"
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid>

                    </Grid>

                </Box>
            </Modal>
        </>
    )
};

export default SupportSheetPrincipleModal;